import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Programs } from "@/components/landing/Programs";
import { CampCalendar } from "@/components/landing/CampCalendar";
import { EnrollForm } from "@/components/landing/EnrollForm";
import { ParentInfo } from "@/components/landing/ParentInfo";
import { Disclaimers } from "@/components/landing/Disclaimers";
import { FAQSection } from "@/components/landing/FAQSection";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/calendar").then((res) => setEvents(res.data)).catch(() => setEvents([]));
  }, []);

  return (
    <div className="min-h-screen bg-yellow-50 font-body">
      <Header />
      <main>
        <Hero />
        <About />
        <Programs />
        <CampCalendar events={events} />

        <section id="enroll" data-testid="enroll-section" className="bg-yellow-50 py-16 sm:py-24">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-8 items-start">
            <EnrollForm events={events} />
            <ParentInfo />
          </div>
        </section>

        <Disclaimers />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}
